import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

import { frame, nose, earsocks, icons, reflection } from './ultras.mjs'

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clear: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8clear-{nnn}.png',
    },
    a_gold: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8gold-{nnn}.png',
    },
    a_silverblue: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8silverblue-{nnn}.png',
    },
    a_smoke: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8smoke-{nnn}.png',
    },
    a_plum: {
      pathTemplate: 'gs://sg360/260903/ule_a_8plum--{nnn}.png',
    },
    a_IRsmoke: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRISsmoke-{nnn}.png',
    },
    a_IRhvblue: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRIShvblue-{nnn}.png',
    },
    a_IRgold: {
      pathTemplate: 'gs://sg360/260903/ule_a_8IRgold--{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    a_IRsmoke: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRISsmoke-{nnn}_overlay.png',
    },
    a_IRhvblue: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRIShvblue-{nnn}_overlay.png',
    },
    a_IRgold: {
      pathTemplate: 'gs://sg360/260903/ule_a_8IRgold--{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Ultras/ulg/ulg_N_{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  return {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
    icons: getSKUWithoutPrefix(customisedProduct.iconChoice.sku),
    engraving: 'eN',
    iris: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    reflections: 'r5pc',
  }
}

export default {
  supports360: false,
  layers: [background, frame, nose, earsocks, icons, lenses, iris, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
